import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIError } from "../../constants/types";
import { api } from "../../api/api";
import { ERROR_MESSAGES } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import { ISharedMailbox } from "./sharedMailbox.types";
import { handleApiError } from "./outlookThunk";

export const fetchSharedMailboxes = createAsyncThunk<
  { list: ISharedMailbox[] },
  void,
  { state: IStoreState; rejectValue: APIError }
>(
  "outlook/fetchSharedMailboxes",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await api.get("/outlook/shared-mailboxes");
      return {
        list: res.data.data,
      };
    } catch (err: any) {
      handleApiError(err, dispatch);
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  },
);

export const registerSharedMailbox = createAsyncThunk<
  ISharedMailbox,
  { shared_mailbox_email: string; display_name: string },
  { state: IStoreState; rejectValue: APIError }
>(
  "outlook/registerSharedMailbox",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const res = await api.post("/outlook/shared-mailboxes", payload);
      return res.data.data;
    } catch (err: any) {
      handleApiError(err, dispatch);
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  },
);

export const verifySharedMailbox = createAsyncThunk<
  { hasAccess: boolean; reason: string },
  { email: string },
  { state: IStoreState; rejectValue: APIError }
>(
  "outlook/verifySharedMailbox",
  async ({ email }, { rejectWithValue, dispatch }) => {
    try {
      const res = await api.get(
        `/outlook/shared-mailboxes/${encodeURIComponent(email)}/verify`,
      );
      return {
        hasAccess: res.data.data.hasAccess,
        reason: res.data.data.reason,
      };
    } catch (err: any) {
      handleApiError(err, dispatch);
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  },
);

export const unregisterSharedMailbox = createAsyncThunk<
  { email: string },
  { email: string },
  { state: IStoreState; rejectValue: APIError }
>(
  "outlook/unregisterSharedMailbox",
  async ({ email }, { rejectWithValue, dispatch }) => {
    try {
      await api.delete(
        `/outlook/shared-mailboxes/${encodeURIComponent(email)}`,
      );
      return { email };
    } catch (err: any) {
      if (err.response?.status === 404) {
        dispatch(fetchSharedMailboxes());
      }
      handleApiError(err, dispatch);
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  },
);
